import { Component, computed, inject, input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { UiService } from '../../services/ui.service';
import { I18nService } from '../../services/i18n.service';
import { BannerNotificationService } from '../../services/banner-notification.service';
import { TabMenuComponent } from '../tab-menu/tab-menu';
import { BannerNotificationComponent } from '../banner-notification/banner-notification.component';
import { LP_UI_CONFIG } from '../../core/tokens';

@Component({
  selector: 'app-desktop-header',
  imports: [RouterLink, NzIconModule, TabMenuComponent, BannerNotificationComponent],
  templateUrl: './desktop-header.html',
  styleUrls: ['./desktop-header.scss'],
})
export class DesktopHeaderComponent {
  private readonly router = inject(Router);
  private readonly ui = inject(UiService);
  public cfg = inject(LP_UI_CONFIG);

  public readonly i18n = inject(I18nService);
  private readonly bannerNotificationService = inject(BannerNotificationService);

  //  Angular 20 Inputs as signals
  readonly title = input<string>('');
  //readonly backToInput = input<string>('', { alias: 'backTo' });
  readonly backTo = input<string>('');

  //  Read state directly from UiService signals
  readonly backBtn = computed(() => this.ui.BackBtn());

  // If UiService doesn't have BackBtnText yet, add it as shown above.
  readonly backToValue = computed(() => {
    const serviceText = this.ui.updateBackBtnText() ?? '';
    return serviceText || this.backTo();
  });

  back(): void {
    this.ui.goBack();
  }

  toSettings(): void {
    this.router.navigate(['settings']);
  }
}
